import { render } from "./SplashSceen.vue?vue&type=template&id=463921e6"
import script from "./SplashSceen.vue?vue&type=script&lang=js"
export * from "./SplashSceen.vue?vue&type=script&lang=js"

import "./SplashSceen.vue?vue&type=style&index=0&id=463921e6&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__